<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20.001" height="20.001" viewBox="0 0 20.001 20.001"><path class="map-a" d="M-1868-6773a10.012,10.012,0,0,1-10-10,10.012,10.012,0,0,1,10-10,10.012,10.012,0,0,1,10,10A10.012,10.012,0,0,1-1868-6773Zm-1.667-6.167h0l3.334,1.166,3.134-1.055a.283.283,0,0,0,.2-.268v-8.4a.275.275,0,0,0-.278-.278l-.089.017-2.966,1.149-3.335-1.167-3.132,1.056a.282.282,0,0,0-.2.268v8.4a.275.275,0,0,0,.278.278l.089-.017,2.966-1.149Zm3.335.055h0l-3.333-1.171v-6.606l3.335,1.171v6.6Z" transform="translate(1878.001 6793)"/></svg>
</template>

<script>
	export default {
		name: 'bw-map'
	}
</script>

<style>
	.map-a {
		fill: #fff;
	}
</style>